

import React, {useState} from 'react';
import img1 from "../../Images/UnilusBGWhole.jpg"
import "./OurStrength.css"
import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin, faArrowRight, faChevronRight, faGlobe, faDiagramProject, faChartLine } from '@fortawesome/free-solid-svg-icons'
import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';


function OurStrength() { 
 

  return <>

        <div className='OurStrengthCover'>

            <div className='innerContent'>

                <div className='CMSWording'>
                            
                            <h3 className="solidLine">WHAT SETS UNILUS ONLINE APART? </h3>

                    </div>
                    <div className='ourStrengthWording'>
                          <p>Our flexible, online programs are designed to bring the UNILUS School classroom to you, and are built around three key characteristics:</p>
                    </div>
                    <div className='OurStrengthCardsCover'> 

                          <div className='OurStrengthCard'>

                              <div className='OurStrengthLogo'> 

                                  <FontAwesomeIcon className='fontIcon' icon={faGlobe} />

                              </div>
                              <div className='OurStrengthHeading'>
                                  <h3>Practical Learning </h3>
                              </div>
                              <div className='OurStrengthWording'>

                                  <p>
                                  Immerse yourself in a practical learning experience that bridges the gap between theory and real-world application. Here, you'll have the opportunity to tackle authentic scenarios and case studies that reflect the challenges faced by industry professionals. 

                                  </p>

                              </div>
                        

                        </div>
                        {/* End of card */}
                          <div className='OurStrengthCard'>

                              <div className='OurStrengthLogo'> 

                                 <FontAwesomeIcon className='fontIcon' icon={faDiagramProject} />

                              </div>
                              <div className='OurStrengthHeading'>
                                  <h3>Equip </h3>
                              </div>
                              <div className='OurStrengthWording'>

                                  <p>
                                  You'll have the opportunity to master essential tools, ensuring you're well-prepared to navigate the complexities of the business landscape. Whether it's strategic decision-making, financial analysis, leadership development, or any other critical domain.
                                  </p>

                              </div>
                        

                        </div>
                        {/* End of card */}
                          <div className='OurStrengthCard'>

                              <div className='OurStrengthLogo'> 

                                   <FontAwesomeIcon className='fontIcon' icon={faChartLine} />

                              </div>
                              <div className='OurStrengthHeading'>
                                  <h3>Flexible
                                         </h3>
                              </div>
                              <div className='OurStrengthWording'>

                                  <p>
                                    
                                  Recognizing the unique demands and constraints that today's professionals face, our programs are designed to offer unparalleled flexibility. We understand that balancing work, personal commitments, and professional development can be challenging, which is why we've crafted an experience that seamlessly integrates into your busy schedule.
                                  </p>

                              </div>
                        

                        </div>
                        {/* End of card */}


                    </div>
            </div>
            
        </div>
       
    
  </>
  
  ;
}

export default OurStrength;